import { defineStore } from "pinia";
import Vue, { ref } from "vue";
import axios from "axios";
import { POSITION, TYPE } from "vue-toastification";
import i18n from "@/i18n";
import { Synergy, SynergyInfo } from "@/model/synergy";

export const useSynergyStore = defineStore("synergy", () => {
  const synergy = ref<SynergyInfo>({
    unami: "",
    unamiPerception: "",
    id: 0,
    molecules: [],
    name: "",
    other: "",
    reportedThresholdConcentrationOfUnami: "",
  });
  const synergies = ref<Synergy[]>([]);

  const getSynergies = async () => {
    await axios
      .get<Synergy[]>("/synergy")
      .then((res) => (synergies.value = res.data));
  };
  const getSynergyById = async (id: number) => {
    await axios
      .get<SynergyInfo>(`/synergy/${id}`)
      .then((res) => (synergy.value = res.data));
  };

  const addSynergy = async () => {
    await axios
      .post<Synergy>("/synergy", synergy.value)
      .then((res) => {
        synergies.value.push(res.data);
        Vue.$toast(i18n.t("synergy.toast.add.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("synergy.toast.add.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const updateSynergy = async () => {
    await axios
      .patch<SynergyInfo>(`/synergy/${synergy.value.id}`, synergy.value)
      .then(() => {
        Vue.$toast(i18n.t("synergy.toast.update.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("synergy.toast.update.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const deleteSynergy = async (id) => {
    await axios
      .delete(`/synergy/${id}`)
      .then((res) => {
        const idx: number = synergies.value.findIndex(
          (item) => item.id === res.data.id
        );
        synergies.value.splice(idx, 1);
        Vue.$toast(i18n.t("synergy.toast.delete.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("synergy.toast.delete.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  return {
    synergy,
    synergies,
    getSynergies,
    getSynergyById,
    addSynergy,
    updateSynergy,
    deleteSynergy,
  };
});
